skrilla.directive('dota2DailyRosters',function() {
    return {
        templateUrl: 'directives/dota2DailyRosters/dota2DailyRosters.html',
        scope: {
            contest: "=",
            userId: "="
        },
        controller: function($scope, searchService, paginationService, queryService, contestsService){
            $scope.getLocalWinAmount = contestsService.getLocalWinAmount;
            $scope.pageKey = "contestRosters";
            $scope.reset = function() {
                $scope.query = {
                    limit: 20,
                    contestId: "" + $scope.contest.contestId,
                    userId: "",
                    draft: false,
                    submitted: true
                };
            }
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getRosters, $scope.pageKey);
            }

            var getRosters = function() {
                return searchService.get("dota2/contests/daily/" + $scope.contest.contestId + "/rosters" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.rosters = response.data.result;
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            if($scope.userId !== undefined){
                $scope.query.userId = $scope.userId;
                $scope.search();
            }

        }
    };
});
